import {ManufacturerPageConfig} from '@/config/manufacturerPageConfig'
import {renderManufacturerRating, renderProductsListRatings} from '@/modules'
import {ready} from '@/shared'

ready(function () {
  renderManufacturerRating(ManufacturerPageConfig.manufacturerId)
  renderProductsListRatings()
})



// WEBPACK FOOTER //
// ./src/manufacturer.js